<template>
  <vs-row class="bg-white shadow py-5 px-3 mb-4">
    <vs-col vs-lg="12">
      <div class="d-block">
        <div style="text-align: right;margin-bottom: 5px;">
      <span>
        Viendo documentos enviados
      </span>
          <span v-if="rangeSelected.valor !== 'personalizado'">
        {{ rangeSelected.nombre }}
      </span>
          <span v-if="rangeSelected.valor === 'personalizado'">
        entre el
            <!--<input type="date" class="fecha" v-model="periodoDesde">-->
        <datetime
          v-model="rangeFrom"
          input-class="form-control input-date"
          :phrases="{ok: 'Seleccionar',
           cancel: 'Cancelar'}"
          value-zone="local"
          format="yyyy-MM-dd"
          data-cy="start-time"
        />
        y el
        <datetime
          v-model="rangeUntil"
          input-class="form-control input-date"
          :phrases="{ok: 'Seleccionar', cancel: 'Cancelar'}"
          value-zone="local"
          format="yyyy-MM-dd"
          data-cy="end-time"
        />
        <span>
          <vs-button
            radius
            class="ml-3 d-inline"
            color="primary"
            type="border"
            icon="search"
            size="small"
            @click="appliFilters()"
          />
        </span>
      </span>
          <vs-dropdown vs-trigger-click style="margin-left: 15px">
            <a class="a-icon" href="#">
              Cambiar
              <vs-icon class="" icon="expand_more"></vs-icon>
            </a>
            <vs-dropdown-menu>
              <vs-dropdown-item
                style="width:200px"
                v-for="range in ranges"
                :key="range.valor"
                v-on:click.native="selectRange(range)"
              >
                {{ range.nombre }}
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </div>
    </vs-col>
    <vs-col vs-lg="1">
      <b-button
        v-tooltip="'Buscar'"
        variant="primary"
        class="btn-icon rounded-circle p-3"
        size="sm"
        v-on:click="appliFilters()"
      >
        <feather-icon icon="SearchIcon"/>
      </b-button>
    </vs-col>
    <vs-col vs-lg="2" v-if="isSuperAdmin">
      <v-select
        placeholder="Ambiente"
        multiple
        :reduce="item => item.value"
        label="title"
        :options="availableEnvironments"
        v-model="filtros.stage.value"
      >
      </v-select>
    </vs-col>
    <vs-col vs-lg="2" v-if="isSuperAdmin && filtros.empresa.value.length > 0">
      <vs-chip class="mt-2 ml-5">
        <vs-avatar
          icon="delete"
          color="red"
          v-on:click="removeCompany()"
        />
        {{ filtros.empresa.value[0] }}
      </vs-chip>
    </vs-col>
    <vs-col v-if="isSuperAdmin" :vs-lg="filtros.empresa.value.length > 0 ? 6: 9">
      <input
        v-model="filtros.search.value"
        placeholder="Buscar"
        class="form-control"
        data-cy="search"
        v-on:keypress.enter="appliFilters"
      />
    </vs-col>
    <vs-col v-if="!isSuperAdmin" :vs-lg="11">
      <input
        v-model="filtros.search.value"
        placeholder="Buscar"
        class="form-control"
        data-cy="search"
        v-on:keypress.enter="appliFilters"
      />
    </vs-col>
  </vs-row>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';

import { DATE_RANGES } from '@/febos/chile/commons/dateCommons';
import SelectorDateMixin from '@/febos/global/_vue/componentes/filtersLetty/SelectorDateMixin';

const environments = [
  {
    title: 'Desarrollo',
    value: 'desarrollo'
  },
  {
    title: 'Pruebas',
    value: 'pruebas'
  },
  {
    title: 'Certificación',
    value: 'certificacion'
  },
  {
    title: 'Produccion',
    value: 'produccion'
  }
];
const currentStage = process.env.VUE_APP_AMBIENTE;
export default {
  name: 'ListFilter',
  mixins: [SelectorDateMixin],

  components: {},
  data() {
    return {
      ranges: DATE_RANGES,
      rangeSelected: { nombre: 'los últimos 6 meses', valor: 'ultimos6meses' },
      rangeFrom: '',
      rangeUntil: '',
      search: '',
      filtros: {
        stage: {
          key: 'stage',
          name: 'Ambiente',
          type: 'multi-keyword',
          value: [currentStage]
        },
        empresa: {
          key: 'empresa',
          name: 'Empresa',
          type: 'multi-keyword',
          value: []
        },
        search: {
          key: 'search',
          type: 'multi_term',
          value: '',
          fields: [
            'id',
            'messageId',
            'documentoId',
            'destinatarios',
            'subject'
          ]
        }
      }
    };
  },
  computed: {
    ...mapGetters('Empresas', ['company']),
    ...mapGetters('Emails', ['page', 'itemsPerPage']),
    ...mapGetters('Usuario', [
      'hasPermission'
    ]),
    isSuperAdmin() {
      return this.hasPermission('FEB99');
    },
    availableEnvironments() {
      return environments;
    },
    avalaibleFiltersSearch() {
      return Object.entries(this.filtros).filter(([, value]) => value.name).map(([, value]) => ({
        key: value.key,
        name: value.name
      }));
    },
    queryFilters() {
      const query = [];
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const filtrosKey in this.filtros) {
        const filter = this.filtros[filtrosKey];
        const { type } = filter;
        let condicion;
        if (type === 'multi_match') {
          const { fields, value } = filter;
          if (value) {
            condicion = {
              multi_match: {
                query: value,
                fields
              }
            };
          }
        } else if (type === 'multi_term') {
          const { fields, value } = filter;
          if (value) {
            condicion = {
              bool: {
                should: fields.map((field) => ({
                  term: {
                    [`${field}.keyword`]: {
                      value,
                      boost: 1.0
                    }
                  }
                })),
                adjust_pure_negative: true,
                boost: 1.0
              }
            };
          }
        } else {
          const filterValue = Array.isArray(filter.value) ? filter.value : [filter.value];
          if (filterValue.length === 0) {
            // eslint-disable-next-line no-continue
            continue;
          } else if (filterValue.length > 1) {
            condicion = {
              bool: {
                should: filterValue.map(
                  (value) => this.generateTermCondition({ ...filter, value })
                ),
                adjust_pure_negative: true,
                boost: 1.0
              }
            };
          } else {
            condicion = this.generateTermCondition(filter);
          }
        }
        if (condicion) {
          query.push(condicion);
        }
      }
      if (this.rangeSelected.valor === 'personalizado') {
        const dateRange = {
          range: {
            timestamp: {
              from: `${this.rangeFrom.split('T')[0]}`,
              to: `${this.rangeUntil.split('T')[0]}`,
              include_lower: true,
              include_upper: true,
              boost: 1
            }
          }
        };
        query.push(dateRange);
      } else {
        const dateRange = {
          range: {
            timestamp: {
              from: `${this.rangeFrom}`,
              to: `${this.rangeUntil}`,
              include_lower: true,
              include_upper: true,
              boost: 1
            }
          }
        };
        query.push(dateRange);
      }
      return {
        bool: {
          filter: query,
          adjust_pure_negative: true,
          boost: 1.0
        }
      };
    }
  },
  watch: {
    page() {
      this.debounceFetchData();
    },
    itemsPerPage() {
      this.debounceFetchData();
    }
  },
  methods: {
    ...mapActions('Emails', ['getEmailsList', 'movePage']),
    generateTermCondition({ key, type = 'multi-keyword', value }) {
      let sufix = '';
      if (type === 'multi-keyword') {
        sufix = '.keyword';
      }
      const filterValue = Array.isArray(value) ? value : [value];
      return {
        term: {
          [`${key}${sufix}`]: {
            value: filterValue[0],
            boost: 1.0
          }
        }
      };
    },
    async fetchData() {
      this.debounceFetchData();
    },
    debounceFetchData: _.debounce(async function debounceFetchData() {
      const query = {
        query: this.queryFilters,
        page: this.page,
        itemPerPage: this.itemsPerPage,
      };
      await this.getEmailsList(query);
    }, 100),
    removeCompany() {
      this.filtros.empresa.value = [];
      this.appliFilters();
    },
    appliFilters() {
      this.movePage(1);
      this.debounceFetchData();
    },
    changeFilters() {
      console.log('cambiando a fechas personalizadas');
    },
  },
  mounted() {
    this.selectRange(this.rangeSelected, true);
    this.filtros.empresa.value.push(this.company.iut);
    this.fetchData();
  }
};
</script>
<style scoped>
.loadData {
  height: 80vh;
}
</style>
